<template>
    <section class="block-hero relative">
        <div class="b-hero__background absolute bg-cover bg-center w-full h-full"></div>
        <div
            class="b-hero__content text-white grid max-w-screen-xl px-4 py-16 mx-auto md:gap-8 xl:gap-0 md:py-20 md:grid-cols-12">
            <div class="mr-auto place-self-center md:col-span-7 z-10">
                <h1
                    class="max-w-2xl mb-4 text-4xl font-extrabold tracking-tight md:text-5xl xl:text-6xl line-clamp-2 break-words md:leading-[1.2] xl:leading-[2]">
                    {{ hero.title }}
                </h1>
                <p class="max-w-2xl mb-6 font-light line-clamp-3 md:mb-8 md:text-md md:text-xl">
                    {{ hero.text }}
                </p>
                <a v-if="hero.button.text" type="button" :href="hero.button.link"
                    class="button">
                    {{ hero.button.text }}
                </a>
            </div>
        </div>
    </section>
</template>

<script setup>
import { defineProps } from 'vue';

defineProps({
    hero: {
        type: Object,
        required: true
    }
})
</script>